<template>
  <div>
    <p>{{ printDate(stats?.updated_at, 'DD.MM.YYYY') }}</p>
    <template v-if="+(stats?.extra_data?.in_stores || 0) === 0">
      <p>нет в аптеках</p>
      <p><strong>{{
          printDate(stats?.extra_data?.last_date, 'DD.MM.YYYY')
        }}</strong>
        - <span>{{ stats?.extra_data?.last_price || 0 }}р</span>
      </p>
    </template>
    <template v-else>
      <p>мин. <strong>{{ stats?.extra_data?.min_price || 0 }}</strong> Ø
        <strong>{{ stats?.extra_data?.avarage_price || 0 }}</strong></p>
      <p>аптек: <strong>{{ stats?.extra_data?.in_stores || 0 }}</strong></p>
    </template>
    <p></p>
  </div>
</template>

<script>

export default {
  props: ['stats']
}

</script>
